module.exports = __webpack_public_path__ + "img/logo.06b1d4b1.svg";